import FileHelper from './file-helper';
import ImageHelper from './image-helper';
import moment from 'moment';
import _ from 'lodash';
import uuid from 'uuid/v1';

export {
    FileHelper,
    ImageHelper
};

export const generateRandomFileName = (originalFileName) => {
    const now = moment().format('YYYY-MMDD');
    const random = uuid();
    const filename = `${now}-${random}`;
    const position = originalFileName.indexOf('.');
    if (position === -1) {
        return filename;
    } else {
        const extension = extractExtensionName(originalFileName);
        return `${filename}${extension}`;
    }
};

export const extractExtensionName = (fileName) => {
    return fileName.substring(fileName.lastIndexOf('.'));
};

/**
 * 从后端文件数据返回值中摘取/转换字段
 * 以便使其符合上传时的参数要求
 *
 * @param object
 */
export const extratFileInfo = (object) => {
    if (object === null) return null;
    return {
        name: _.get(object, 'name', null),
        path: _.get(object, 'storage_path', null),
        random_name: _.get(object, 'storage_name', '') + _.get(object, 'extension_name', ''),
        size: _.get(object, 'size', null)
    };
};
